export default "__VITE_ASSET__76e28487__"